var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.comments)?_c('div',{staticClass:"comments"},[_c('h3',[_vm._v(_vm._s(_vm.comments.length)+" Comments")]),(_vm.comments)?_c('div',_vm._l((_vm.comments),function(comment){return _c('SingleComment',{key:comment.id,attrs:{"comment":comment}})}),1):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }